// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-time-cell-badge[data-v-7d483e6e]{padding-top:.32rem !important}", ""]);
// Exports
module.exports = exports;
